import { useEffect } from "react";

const SITE = "Canarias Market";

function upsert(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  return el;
}

function setMeta(attr, key, content) {
  const el = upsert(`meta[${attr}="${key}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(attr, key);
    return m;
  });
  el.setAttribute("content", content || "");
}

export function defaultOgImage() {
  return `${window.location.origin}/logo.png`;
}

// Dynamic SEO: title + description + Open Graph + Twitter card.
export function useSeo({ title, description, image, type = "website" }) {
  useEffect(() => {
    const fullTitle = title || SITE;
    const desc = description || "";
    const img = image || defaultOgImage();
    document.title = fullTitle;

    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:image", img);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
  }, [title, description, image, type]);
}
